// extracted by mini-css-extract-plugin
export var actionButton = "_sh-0";
export var actionMenuContainer = "_sh-i";
export var bubble = "_sh-2";
export var bubbleActionMenu = "_sh-j";
export var bubbleContext = "_sh-6";
export var bubbleItems = "_sh-7";
export var customer = "_sh-3";
export var divider = "_sh-8";
export var fileList = "_sh-9";
export var hiddenComment = "_sh-o";
export var infoAbove = "_sh-a";
export var internal = "_sh-4";
export var lightActionButton = "_sh-1";
export var link = "_sh-b";
export var merchant = "_sh-5";
export var message = "_sh-c";
export var profilePicture = "_sh-e";
export var quillToolbarContainer = "_sh-f";
export var senderDate = "_sh-g";
export var senderDateCustomer = "_sh-h";
export var senderName = "_sh-d";
export var time = "_sh-k";
export var uploadedImage = "_sh-l";
export var username = "_sh-m";
export var xsmall = "_sh-n";